<template>
  <div id="register-form-add-or-update-dialog" class="custom-modal">
    <div class="modal-body" id="scroll-area">
      <transition name="el-fade-in" mode="out-in">
        <HolaconLottie v-if="createLoading == 'created'" key="create-loading" />
        <el-tabs v-else tab-position="left" v-model="activeKey" key="register-form-dialog-content" class="register-form-tab" @tab-click="handleClick">
          <el-tab-pane :label="$t('registrationManagement.registrationForm.registerFormDialog.formInformations.tabName')" name="one">
            <el-card shadow="never" class="form-base-card" v-if="currentForm.formInfo">
              <div class="header">
                <div class="title">
                  {{ $t("registrationManagement.registrationForm.registerFormDialog.formInformations.tabName") }}
                  <span v-html="$t('registrationManagement.registrationForm.registerFormDialog.formInformations.topMsg')"></span>
                </div>
              </div>
              <div class="tab-contents">
                <div class="registerform-input-container">
                  <div class="custom-label">
                    <label>
                      {{ $t("registrationManagement.registrationForm.registerFormDialog.formInformations.title") }}
                    </label>
                    <el-tooltip placement="top">
                      <div slot="content" class="custom-tooltip-content">
                        <span>
                          {{ $t("registrationManagement.registrationForm.registerFormDialog.formInformations.titleMsg") }}
                        </span>
                      </div>
                      <i class="el-icon-info"></i>
                    </el-tooltip>
                  </div>
                  <el-input type="text" v-model="currentForm.formInfo.title"></el-input>
                  <span class="error">{{ $errorMessage("title", validationErrors) }}</span>
                </div>
                <div class="registerform-input-container">
                  <div class="custom-label">
                    <label>{{ $t("registrationManagement.registrationForm.registerFormDialog.formInformations.language") }}</label>
                    <el-tooltip placement="top">
                      <div slot="content" class="custom-tooltip-content">
                        <span v-html="$t('registrationManagement.registrationForm.registerFormDialog.formInformations.languageMsg')"></span>
                      </div>
                      <i class="el-icon-info"></i>
                    </el-tooltip>
                  </div>
                  <el-select v-if="getEnums" v-model="currentForm.formInfo.language">
                    <el-option v-for="(item, index) in getEnums.find(x => x.title == 'RegistrationFormLanguage').enums" :key="index" :label="item.displayName" :value="item.key"></el-option>
                  </el-select>
                  <span class="error">{{ $errorMessage("language", validationErrors) }}</span>
                </div>
                <div class="registerform-input-container">
                  <div class="custom-label">
                    <label>{{ $t("registrationManagement.registrationForm.registerFormDialog.formInformations.topBanner") }}</label>
                    <el-tooltip placement="top">
                      <div slot="content" class="custom-tooltip-content">
                        <span>{{ $t("registrationManagement.registrationForm.registerFormDialog.formInformations.topBannerRecommend") }}</span>
                      </div>
                      <i class="el-icon-info"></i>
                    </el-tooltip>
                    <div class="ml-auto" v-if="currentForm.formInfo && currentForm.formInfo.topBanner != null">
                      <el-popconfirm @confirm="currentForm.formInfo.topBanner = null" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('registrationManagement.registrationForm.registerFormDialog.formInformations.topBannerSureRemove')">
                        <i slot="reference" class="fas fa-trash text-danger cursor-pointer"></i>
                      </el-popconfirm>
                    </div>
                  </div>
                  <el-upload class="upload-demo" drag :action="axios.defaults.baseURL + 'event/uploadImage?uploadType=registrationBanner&language=' + $i18n.locale" :headers="{ Authorization: axios.defaults.headers['Authorization'] }" :show-file-list="false" :on-success="topBannerSuccess">
                    <img v-if="currentForm.formInfo.topBanner" :src="currentForm.formInfo.topBanner" class="banner-img" />
                    <template v-else>
                      <i class="el-icon-upload"></i>
                      <div class="el-upload__text" v-html="$t('registrationManagement.registrationForm.registerFormDialog.formInformations.uploadText')"></div>
                      <div class="el-upload__tip" slot="tip">{{ $t("registrationManagement.registrationForm.registerFormDialog.formInformations.topBannerMaxSize") }}</div>
                    </template>
                  </el-upload>
                  <span class="error">{{ $errorMessage("language", validationErrors) }}</span>
                </div>
                <div class="registerform-input-container">
                  <div class="custom-label">
                    <label>{{ $t("registrationManagement.registrationForm.registerFormDialog.formInformations.content") }}</label>
                    <el-tooltip placement="top">
                      <div slot="content" class="custom-tooltip-content">
                        <span>{{ $t("registrationManagement.registrationForm.registerFormDialog.formInformations.contentMsg") }}</span>
                      </div>
                      <i class="el-icon-info"></i>
                    </el-tooltip>
                  </div>
                  <quill-editor ref="myQuillEditor" @ready="onEditorReady($event)" :options="editorOptionImage" v-model="currentForm.formInfo.infoText" />
                </div>
                <div class="registerform-input-container">
                  <div class="custom-label">
                    <label>{{ $t("registrationManagement.registrationForm.registerFormDialog.formInformations.subBanner") }}</label>
                    <el-tooltip placement="top">
                      <div slot="content" class="custom-tooltip-content">
                        <span>{{ $t("registrationManagement.registrationForm.registerFormDialog.formInformations.subBannerRecommend") }}</span>
                      </div>
                      <i class="el-icon-info"></i>
                    </el-tooltip>
                    <div class="ml-auto" v-if="currentForm.formInfo && currentForm.formInfo.bottomBanner != null">
                      <el-popconfirm @confirm="currentForm.formInfo.bottomBanner = null" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('registrationManagement.registrationForm.registerFormDialog.formInformations.subBannerSureRemove')">
                        <i slot="reference" class="fas fa-trash text-danger cursor-pointer"></i>
                      </el-popconfirm>
                    </div>
                  </div>
                  <el-upload
                    class="upload-demo"
                    drag
                    :action="axios.defaults.baseURL + 'event/uploadImage?uploadType=registrationBanner&language=' + $i18n.locale"
                    :headers="{
                      Authorization: axios.defaults.headers['Authorization']
                    }"
                    :show-file-list="false"
                    :on-progress="bottomBannerProgress"
                    :on-success="bottomBannerSuccess"
                  >
                    <img v-if="currentForm.formInfo.bottomBanner" :src="currentForm.formInfo.bottomBanner" class="banner-img" />
                    <template v-else>
                      <i class="el-icon-upload"></i>
                      <div class="el-upload__text" v-html="$t('registrationManagement.registrationForm.registerFormDialog.formInformations.uploadText')"></div>
                      <div class="el-upload__tip" slot="tip">{{ $t("registrationManagement.registrationForm.registerFormDialog.formInformations.subBannerMaxSize") }}</div>
                    </template>
                  </el-upload>
                </div>
              </div>
            </el-card>
          </el-tab-pane>

          <el-tab-pane :label="$t('registrationManagement.registrationForm.registerFormDialog.paymentInformations.tabName')" name="two">
            <el-card shadow="never" class="form-base-card" v-if="currentForm.paymentInfo">
              <div class="header">
                <div class="title">
                  {{ $t("registrationManagement.registrationForm.registerFormDialog.paymentInformations.tabName") }}
                  <span v-html="$t('registrationManagement.registrationForm.registerFormDialog.paymentInformations.topMsg')"></span>
                </div>
              </div>
              <el-radio-group class="custom-radio-group" v-model="currentForm.paymentInfo.formRegistrationType" @change="formRegistrationTypeRadio">
                <el-radio-button v-for="(item, index) in getEnums.find(x => x.title == 'RegistrationFormFormRegistrationType').enums" :key="index" :label="item.key">{{ item.displayName }}</el-radio-button>
              </el-radio-group>
              <div class="tab-contents">
                <el-row :gutter="20" class="custom-tab-content-row" v-if="currentForm.paymentInfo.formRegistrationType == 1">
                  <el-col :span="24" class="mb-3">
                    <div class="registerform-input-container">
                      <div class="custom-label">
                        <label>{{ $t("registrationManagement.registrationForm.registerFormDialog.paymentInformations.currency") }}</label>
                        <el-tooltip placement="top">
                          <div slot="content" class="custom-tooltip-content">
                            <span>{{ $t("registrationManagement.registrationForm.registerFormDialog.paymentInformations.currencyMsg") }}</span>
                          </div>
                          <i class="el-icon-info"></i>
                        </el-tooltip>
                      </div>
                      <el-select v-if="getEnums" v-model="currentForm.paymentInfo.currency" @change="changeCurrency">
                        <el-option v-for="(item, index) in getEnums.find(x => x.title == 'Currency').enums.filter(x => x.key != 0)" :key="index" :label="item.displayName" :value="item.key"></el-option>
                      </el-select>
                    </div>
                  </el-col>
                  <el-col>
                    <div class="registerform-input-container">
                      <div class="title">
                        <div>
                          <label>{{ $t("registrationManagement.registrationForm.registerFormDialog.paymentInformations.taxSettings") }}</label>
                          <el-tooltip placement="top">
                            <div slot="content" class="custom-tooltip-content">
                              <span>{{ $t("registrationManagement.registrationForm.registerFormDialog.paymentInformations.taxNameMsg") }}</span>
                            </div>
                            <i class="el-icon-info"></i>
                          </el-tooltip>
                        </div>
                        <el-switch v-model="currentForm.paymentInfo.taxEnabled"></el-switch>
                      </div>
                    </div>
                  </el-col>
                  <el-col v-if="currentForm.paymentInfo.taxEnabled" :span="12" class="mb-3">
                    <div class="registerform-input-container">
                      <div class="title">
                        <div>
                          <label>{{ $t("registrationManagement.registrationForm.registerFormDialog.paymentInformations.taxName") }}</label>
                        </div>
                        <!-- <el-switch v-model="currentForm.paymentInfo.taxEnabled"></el-switch> -->
                      </div>
                      <el-input v-if="currentForm.paymentInfo.taxEnabled" type="text" :disabled="!currentForm.paymentInfo.taxEnabled" v-model="currentForm.paymentInfo.taxName"></el-input>
                    </div>
                  </el-col>
                  <el-col :span="12" class="mb-3" v-if="currentForm.paymentInfo.taxEnabled">
                    <div class="registerform-input-container w-100">
                      <div class="custom-label">
                        <label>{{ $t("registrationManagement.registrationForm.registerFormDialog.paymentInformations.taxRate") }}</label>
                        <el-tooltip placement="top">
                          <div slot="content" class="custom-tooltip-content">
                            <span>{{ $t("registrationManagement.registrationForm.registerFormDialog.paymentInformations.taxRateMsg") }}</span>
                          </div>
                          <i class="el-icon-info"></i>
                        </el-tooltip>
                      </div>
                      <el-input-number v-model="currentForm.paymentInfo.taxPercentage" :min="0" :max="99"></el-input-number>
                    </div>
                  </el-col>
                  <el-col :span="24">
                    <div class="registerform-input-container">
                      <div class="title">
                        <div>
                          <label>{{ $t("registrationManagement.registrationForm.registerFormDialog.paymentInformations.onlinePayment") }}</label>
                          <el-tooltip placement="top">
                            <div slot="content" class="custom-tooltip-content">
                              <span>{{ $t("registrationManagement.registrationForm.registerFormDialog.paymentInformations.onlinePaymentMsg") }}</span>
                            </div>
                            <i class="el-icon-info"></i>
                          </el-tooltip>
                        </div>
                        <el-switch v-model="currentForm.paymentInfo.onlinePayments"></el-switch>
                      </div>
                      <transition name="el-fade-in">
                        <div class="online-payments-container" v-if="currentForm.paymentInfo.onlinePayments">
                          <!-- <el-input v-model="currentForm.paymentInfo.posId"></el-input> -->
                          <!-- <el-select :disabled="!currentForm.paymentInfo.onlinePayments" v-model="currentForm.paymentInfo.posId">
                            <el-option v-for="(item, index) in currentOrganization.posItems.filter(x => x.currency == currentForm.paymentInfo.currency)" :key="index" :label="item.posID" :value="item.posID"></el-option>
                          </el-select> -->
                          <div class="payment-add-buttons">
                            <el-button
                              round
                              icon="fas fa-plus"
                              size="mini"
                              @click="
                                paymentPosId = null;
                                addPaymentMethodDialog = !addPaymentMethodDialog;
                              "
                              type="primary"
                            >
                              {{ $t("registrationManagement.registrationForm.registerFormDialog.paymentInformations.addPayment") }}
                            </el-button>
                          </div>
                          <div class="custom-grid-table-header online-payment-list-header" v-if="currentOrganization.paymentProviders.length > 0">
                            <span>{{ $t("registrationManagement.registrationForm.registerFormDialog.paymentInformations.paymentMethod") }}</span>
                            <span>{{ $t("registrationManagement.registrationForm.registerFormDialog.paymentInformations.currency") }}</span>
                            <span></span>
                          </div>
                          <div class="online-payment-list-items">
                            <div class="item" v-for="posItem in currentOrganization.paymentProviders" :key="posItem.posId">
                              <span>{{ posItem.posId + " - " + posItem.title }}</span>
                              <span>{{ getEnumsDisplay("Currency", posItem.currency) }}</span>
                              <div class="btn-list">
                                <el-tooltip effect="dark" :content="$t('registrationManagement.registrationForm.registerFormDialog.paymentInformations.setActive')" placement="top">
                                  <el-button :type="currentForm.paymentInfo.posId == posItem.posId ? 'success' : 'default'" icon="fas fa-check" :disabled="currentForm.paymentInfo.currency != posItem.currency" circle size="mini" @click="currentForm.paymentInfo.posId = posItem.posId"></el-button>
                                </el-tooltip>
                                <el-tooltip effect="dark" :content="$t('event.table.edit')" placement="top">
                                  <el-button
                                    type="primary"
                                    icon="fas fa-pen"
                                    circle
                                    size="mini"
                                    @click="
                                      paymentPosId = posItem.posId;
                                      addPaymentMethodDialog = !addPaymentMethodDialog;
                                    "
                                  ></el-button>
                                </el-tooltip>
                                <el-tooltip effect="dark" :content="$t('registrationManagement.registrationForm.registerFormDialog.paymentInformations.test')" placement="top">
                                  <el-button
                                    type="warning"
                                    icon="fas fa-credit-card"
                                    circle
                                    size="mini"
                                    @click="
                                      paymentPosId = posItem.posId;
                                      testPaymentModal = !testPaymentModal;
                                    "
                                  ></el-button>
                                </el-tooltip>
                                <el-tooltip effect="dark" :content="$t('event.table.delete')" placement="top">
                                  <el-popconfirm @confirm="deleteProviders(posItem.posId)" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
                                    <el-button slot="reference" type="danger" :loading="loading == 'delete' + posItem.posId" icon="fas fa-trash" circle size="mini"></el-button>
                                  </el-popconfirm>
                                </el-tooltip>
                              </div>
                            </div>
                          </div>
                        </div>
                      </transition>
                    </div>
                  </el-col>
                  <el-col :span="24">
                    <div class="registerform-input-container">
                      <div class="title">
                        <div>
                          <label>{{ $t("registrationManagement.registrationForm.registerFormDialog.paymentInformations.paymentBankTransfer") }}</label>
                          <el-tooltip placement="top">
                            <div slot="content" class="custom-tooltip-content">
                              <span>{{ $t("registrationManagement.registrationForm.registerFormDialog.paymentInformations.paymentBankTransferMsg") }}</span>
                            </div>
                            <i class="el-icon-info"></i>
                          </el-tooltip>
                        </div>
                        <el-switch v-model="currentForm.paymentInfo.wiredPayments"></el-switch>
                      </div>
                      <transition name="el-fade-in">
                        <quill-editor ref="myQuillEditor" @ready="onEditorReady($event)" :options="editorOption" v-if="currentForm.paymentInfo.wiredPayments" v-model="currentForm.paymentInfo.wiredPaymentsInfo" />
                      </transition>
                    </div>
                  </el-col>
                </el-row>
                <el-row :gutter="20" v-else>
                  <el-alert :show-icon="true" type="info" :title="$t('registrationManagement.registrationForm.registerFormDialog.paymentInformations.freePaymentMsg')"></el-alert>
                </el-row>
              </div>
            </el-card>
            <el-dialog :visible.sync="testPaymentModal" :close-on-click-modal="false" :title="$t('registrationManagement.registrationForm.registerFormDialog.paymentInformations.test')" class="medium" center append-to-body destroy-on-close>
              <TestPaymentModal v-if="testPaymentModal" :paymentPosId="paymentPosId" @closeDialog="testPaymentModal = false" />
            </el-dialog>
            <el-dialog :visible.sync="addPaymentMethodDialog" :close-on-click-modal="false" :title="$t('registrationManagement.registrationForm.registerFormDialog.paymentInformations.addEditPayment')" class="medium" center append-to-body destroy-on-close>
              <AddOrUpdatePaymentMethods v-if="addPaymentMethodDialog" :paymentPosId="paymentPosId" @closeDialog="addPaymentMethodDialog = false" @deleteProviders="deleteProviders" />
            </el-dialog>
          </el-tab-pane>

          <el-tab-pane :label="$t('registrationManagement.registrationForm.registerFormDialog.packages.tabName')" name="three">
            <el-card shadow="never" class="form-base-card" v-if="currentForm.settings">
              <div class="header">
                <div class="title">
                  {{ $t("registrationManagement.registrationForm.registerFormDialog.packages.tabName") }}
                  <span v-html="$t('registrationManagement.registrationForm.registerFormDialog.packages.topMsg')"></span>
                </div>
                <el-button round icon="fas fa-plus" type="primary" size="small" @click="addUpdatePacket(null)">{{ $t("registrationManagement.registrationForm.registerFormDialog.packages.addPackage") }}</el-button>
              </div>

              <div class="tab-contents">
                <template v-if="currentForm.packets.length > 0">
                  <div class="packet-head">
                    <div>{{ $t("registrationManagement.registrationForm.registerFormDialog.packages.registrationPackage") }}</div>
                    <div>{{ $t("registrationManagement.registrationForm.registerFormDialog.packages.price") }}</div>
                    <div class="text-center">{{ $t("registrationManagement.registrationForm.registerFormDialog.packages.view") }}</div>
                    <div></div>
                  </div>
                  <draggable id="packet-container" :list="currentForm.packets" tag="div" class="list-group-o" handle=".el-icon-s-grid" v-bind="dragOptions" @start="dragPacket = true" @end="changePacketSort">
                    <div class="item" v-for="item in currentForm.packets" :key="item.id" :class="{ passive: !item.isActive }">
                      <div class="price-title ">
                        <i class="el-icon-s-grid burger" v-if="loading != 'packetChanged-' + item.id"></i>
                        <i class="el-icon-loading" v-if="loading == 'packetChanged-' + item.id"></i>

                        <div class="w-100">
                          <el-input @change="changedPacket(item)" v-model="item.title"></el-input>
                          <span class="error" v-if="getPacketValidation.id == item.id">{{ $errorMessage("title", getPacketValidation.validationErrors) }}</span>
                        </div>
                      </div>

                      <div :style="currentForm.paymentInfo.formRegistrationType === 1 ? { 'align-items': 'center' } : { 'align-items': 'flex-start' }">
                        <template v-if="currentForm.paymentInfo.formRegistrationType == 1">
                          <MoneyInput :min="0" :max="99999" :fixed="2" v-model="item.price" clearable>
                            <template slot="append">{{ getEnumsDisplay("Currency", currentForm.paymentInfo.currency) }}</template>
                          </MoneyInput>
                          <span class="error" v-if="getPacketValidation.id == item.id">
                            {{ $errorMessage("price", getPacketValidation.validationErrors) }}
                          </span>
                        </template>
                        <template v-else>
                          <span>{{ $t("registrationManagement.registrationForm.registerFormDialog.packages.free") }}</span>
                        </template>
                      </div>
                      <div>
                        <el-switch v-model="item.isActive" @change="changedPacket(item)"></el-switch>
                      </div>
                      <div style="display:flex; flex-direction:row; gap:0.5rem;">
                        <el-tooltip placement="top">
                          <div slot="content" class="custom-tooltip-content">
                            <span>{{ $t("registrationManagement.registrationForm.registerFormDialog.packages.edit") }}</span>
                          </div>
                          <el-button type="primary" @click="addUpdatePacket(item.id)" circle icon="fas fa-pen" size="small"></el-button>
                        </el-tooltip>
                        <el-tooltip placement="top">
                          <div slot="content" class="custom-tooltip-content">
                            <span>{{ $t("registrationManagement.registrationForm.registerFormDialog.packages.delete") }}</span>
                          </div>
                          <el-popconfirm :title="$t('registrationManagement.registrationForm.registerFormDialog.packages.deleteSure')" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" @confirm="deletePacket(item.id)" class="post-send-button">
                            <el-button slot="reference" type="danger" circle icon="fas fa-trash" size="small" :loading="loading == 'delete' + item.id"></el-button>
                          </el-popconfirm>
                        </el-tooltip>
                      </div>
                    </div>
                  </draggable>
                </template>
                <el-alert type="info" v-else :show-icon="true" :title="$t('registrationManagement.registrationForm.registerFormDialog.packages.pleaseAddOne')" :closable="false"></el-alert>
              </div>

              <el-dialog :close-on-click-modal="false" :visible.sync="packetDialog" :title="packetId != null ? $t('registrationManagement.registrationForm.registerFormDialog.packages.editPackage') : $t('registrationManagement.registrationForm.registerFormDialog.packages.addPackage')" class="xlarge" center append-to-body destroy-on-close>
                <AddOrUpdateRegistrationPacket :id="packetId" :formId="id" @closeDialog="closePacketDialog" v-if="packetDialog" @deleteMe="deletePacket" />
              </el-dialog>
            </el-card>
          </el-tab-pane>
          <el-tab-pane :label="$t('registrationManagement.registrationForm.registerFormDialog.questionsAndInformation.tabName')" name="six">
            <el-card class="form-base-card">
              <QuestionLibrary :id="currentForm.id" :key="currentForm.id" v-if="activeKey == 'six'" :type="0" />
            </el-card>
          </el-tab-pane>

          <el-tab-pane :label="$t('registrationManagement.registrationForm.registerFormDialog.couponCodes.tabName')" name="seven" v-if="couponGroups">
            <el-card shadow="never" class="form-base-card">
              <div class="header">
                <div class="title">
                  {{ $t("registrationManagement.registrationForm.registerFormDialog.questionsAndInformation.couponCodes") }}
                  <span>{{ $t("registrationManagement.registrationForm.registerFormDialog.questionsAndInformation.couponCodesMsg") }}</span>
                </div>
                <div class="actions" >
                  <el-button-group v-if="true">
                    <el-tooltip effect="dark" :content="$t('buttonGeneral.searchFilter')" placement="top">
                      <el-button size="small" round icon="fas fa-search" @click="couponFilterDock = !couponFilterDock"></el-button>
                    </el-tooltip>

                    <el-button round icon="fas fa-download" type="warning" size="small" @click="openExcellDialog">
                      {{ $t("registrationManagement.registrationForm.registerFormDialog.couponCodes.export") }}
                    </el-button>

                    <el-button round icon="fas fa-plus" type="primary" size="small" @click="addUpdateCoupon(null)">
                      {{ $t("registrationManagement.registrationForm.registerFormDialog.couponCodes.generateCode") }}
                    </el-button>
                  </el-button-group>
                </div>
              </div>

              <transition name="el-zoom-in-top" mode="out-in">
                <div class="coupon-search-container" v-show="couponFilterDock">
                  <el-input v-model="filter.searchTerm" :placeholder="$t('registrationManagement.registrationForm.registerFormDialog.search')" clearable @clear="filter.searchTerm = null"><i slot="prefix" class="el-input__icon fas fa-search"></i></el-input>
                </div>
              </transition>
              <upgrade-overlay v-if="false" height="300px"></upgrade-overlay>
              <div class="tab-contents" v-else-if="couponGroups.length > 0">
                <div class="coupon-head">
                  <div>{{ $t("registrationManagement.registrationForm.registerFormDialog.couponCodes.title") }}</div>
                  <div>{{ $t("registrationManagement.registrationForm.registerFormDialog.couponCodes.definedPackage") }}</div>
                  <div>{{ $t("registrationManagement.registrationForm.registerFormDialog.couponCodes.attachments") }}</div>
                  <div>{{ $t("registrationManagement.registrationForm.registerFormDialog.couponCodes.codeLimit") }}</div>
                  <div>{{ $t("registrationManagement.registrationForm.registerFormDialog.couponCodes.show") }}</div>
                  <div></div>
                </div>
                <div id="coupon-container">
                  <div class="item" v-for="item in couponGroups" :key="item.id" :class="{ passive: !item.isActive }">
                    <div class="price-title ">
                      <i class="el-icon-loading icon-font" v-if="loading == 'couponChanged-' + item.id"></i>
                      {{ item.title }}
                    </div>
                    <div class="packagelimits">
                      <template v-if="item.isActivePacketLimitations">
                        <el-tooltip placement="top">
                          <div slot="content" class="custom-tooltip-content">
                            <p v-for="packetItem in item.packetLimitations.filter(x => x.type != null)" :key="packetItem.packetId">
                              <template v-if="currentForm.packets.find(x => x.id == packetItem.packetId)">
                                {{ currentForm.packets.find(x => x.id == packetItem.packetId).title }}
                              </template>
                            </p>
                          </div>
                          <span v-if="item.packetLimitations.length > 0">{{ item.packetLimitations.filter(x => x.type != null).length }}</span>
                        </el-tooltip>
                      </template>
                      <template v-else>
                        -
                      </template>
                    </div>
                    <div>{{ item.prefix }} / {{ item.suffix }}</div>
                    <div>{{ item.count }} {{ $t("registrationManagement.registrationForm.registerFormDialog.couponCodes.code") }} {{ item.count * item.limitPerCoupon }} / {{ item.usage }}</div>
                    <el-switch v-model="item.isActive" @change="changedCoupon(item)"></el-switch>
                    <div style="display:flex; flex-direction:row; gap:0.5rem;">
                      <el-tooltip placement="top">
                        <div slot="content" class="custom-tooltip-content">
                          <span>{{ $t("registrationManagement.registrationForm.registerFormDialog.couponCodes.show") }}</span>
                        </div>
                        <el-button type="info" @click="openDetailCoupon(item.id)" circle icon="fas fa-search" size="small"></el-button>
                      </el-tooltip>
                      <el-tooltip placement="top">
                        <div slot="content" class="custom-tooltip-content">
                          <span>{{ $t("registrationManagement.registrationForm.registerFormDialog.couponCodes.edit") }}</span>
                        </div>
                        <el-button type="primary" @click="addUpdateCoupon(item.id)" circle icon="fas fa-pen" size="small" style="margin-left: 0px;"></el-button>
                      </el-tooltip>
                      <el-tooltip placement="top" v-if="item.usageLeft > 0">
                        <div slot="content" class="custom-tooltip-content">
                          <span>{{ $t("registrationManagement.registrationForm.registerFormDialog.couponCodes.reminderBtn") }}</span>
                        </div>
                        <el-button type="warning" v-if="item.usageLeft > 0" @click="reminderCouponGroup(item.id)" :loading="loading == 'reminderCoupon-' + item.id" circle icon="fas fa-bell" size="small" style="margin-left: 0px;"></el-button>
                      </el-tooltip>
                      <el-tooltip placement="top">
                        <div slot="content" class="custom-tooltip-content">
                          <span>{{ $t("registrationManagement.registrationForm.registerFormDialog.couponCodes.delete") }}</span>
                        </div>
                        <el-popconfirm :title="$t('event.textbox.toDelete')" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" @confirm="deleteCoupon(item.id)" class="post-send-button" icon="el-icon-info" iconColor="red">
                          <el-button slot="reference" type="danger" circle icon="fas fa-trash" size="small" :loading="loading == 'delete' + item.id"></el-button>
                        </el-popconfirm>
                      </el-tooltip>
                    </div>
                  </div>
                </div>
              </div>
              <el-alert v-else type="info" :show-icon="true" class="mt-3" :closable="false" :title="$t('registrationManagement.registrationForm.registerFormDialog.couponCodes.noCoupon')"></el-alert>

              <el-dialog :close-on-click-modal="false" :visible.sync="couponDialog" :title="$t('registrationManagement.registrationForm.registerFormDialog.couponCodes.addEditCoupon')" :id="couponId" class="large" center append-to-body destroy-on-close>
                <AddOrUpdateRegistrationCoupon :id="couponId" :formId="id" @closeDialog="couponDialog = false" @refresh="filtered" v-if="couponDialog" />
              </el-dialog>
              <el-dialog :close-on-click-modal="false" :visible.sync="couponDetailDialog" :title="$t('registrationManagement.registrationForm.registerFormDialog.couponCodes.codeList')" class="large" center append-to-body destroy-on-close>
                <RegistrationCouponDetails :id="couponDetailId" @closeDialog="couponDetailDialog = false" v-if="couponDetailDialog" />
              </el-dialog>
            </el-card>
          </el-tab-pane>
          <el-tab-pane :label="$t('registrationManagement.registrationForm.registerFormDialog.contracts.tabName')" name="nine" v-if="currentForm.policies">
            <el-card shadow="never" class="form-base-card">
              <div class="header">
                <div class="title">
                  {{ $t("registrationManagement.registrationForm.registerFormDialog.contracts.registerContract") }}
                  <span>{{ $t("registrationManagement.registrationForm.registerFormDialog.contracts.registerContractMsg") }}</span>
                </div>
              </div>
              <div class="tab-contents">
                <div class="custom-set-container" :class="currentForm.policies.enableKVKK ? 'sactive' : ''">
                  <div class="custom-set-inner">
                    <i :class="currentForm.policies.enableKVKK ? 'fas fa-check-circle' : 'fas fa-times-circle'"></i>
                    <div class="custom-set-info">
                      <label>
                        {{ $t("registrationManagement.registrationForm.registerFormDialog.contracts.gdprContract") }}
                      </label>
                      <span>{{ $t("registrationManagement.registrationForm.registerFormDialog.contracts.gdprContractMsg") }}</span>
                    </div>
                  </div>
                  <div class="custom-set-actions fend">
                    <el-switch v-model="currentForm.policies.enableKVKK"></el-switch>
                  </div>
                  <div class="custom-set-actions fcenter mt-2">
                    <transition name="el-fade-in">
                      <div v-if="currentForm.policies.enableKVKK" style="width: 100%">
                        <div class="registerform-input-container">
                          <div class="custom-label">
                            <label>{{ $t("registrationManagement.registrationForm.registerFormDialog.contracts.gdprTitle") }}</label>
                            <el-tooltip placement="top">
                              <div slot="content" class="custom-tooltip-content">
                                <span>{{ $t("registrationManagement.registrationForm.registerFormDialog.contracts.gdprTitleMsg") }}</span>
                              </div>
                              <i class="el-icon-info"></i>
                            </el-tooltip>
                          </div>
                          <el-input type="text" v-model="currentForm.policies.titleKVKK"></el-input>
                          <span class="error">{{ $errorMessage("titleKVKK", validationErrors) }}</span>
                        </div>
                        <div class="registerform-input-container">
                          <div class="custom-label">
                            <label>{{ $t("registrationManagement.registrationForm.registerFormDialog.contracts.gdprContent") }}</label>
                            <el-tooltip placement="top">
                              <div slot="content" class="custom-tooltip-content">
                                <span>{{ $t("registrationManagement.registrationForm.registerFormDialog.contracts.gdprContentMsg") }}</span>
                              </div>
                              <i class="el-icon-info"></i>
                            </el-tooltip>
                          </div>
                          <quill-editor ref="myQuillEditor" @ready="onEditorReady($event)" :options="editorOption" style="background-color:white; border-radius:8px;" v-model="currentForm.policies.kvkk" />
                        </div>
                      </div>
                    </transition>
                  </div>
                </div>

                <div class="custom-set-container" :class="currentForm.policies.enablePrivacyPolicy ? 'sactive' : ''">
                  <div class="custom-set-inner">
                    <i :class="currentForm.policies.enablePrivacyPolicy ? 'fas fa-check-circle' : 'fas fa-times-circle'"></i>
                    <div class="custom-set-info">
                      <label>
                        {{ $t("registrationManagement.registrationForm.registerFormDialog.contracts.privacyPolicy") }}
                      </label>
                      <span>{{ $t("registrationManagement.registrationForm.registerFormDialog.contracts.privacyPolicyMsg") }}</span>
                    </div>
                  </div>
                  <div class="custom-set-actions fend">
                    <el-switch v-model="currentForm.policies.enablePrivacyPolicy"></el-switch>
                  </div>
                  <div class="custom-set-actions fcenter mt-2">
                    <transition name="el-fade-in">
                      <div v-if="currentForm.policies.enablePrivacyPolicy" style="width: 100%">
                        <div class="registerform-input-container">
                          <div class="custom-label">
                            <label>{{ $t("registrationManagement.registrationForm.registerFormDialog.contracts.privacyPolicyTitle") }}</label>
                            <el-tooltip placement="top">
                              <div slot="content" class="custom-tooltip-content">
                                <span>{{ $t("registrationManagement.registrationForm.registerFormDialog.contracts.privacyPolicyTitleMsg") }}</span>
                              </div>
                              <i class="el-icon-info"></i>
                            </el-tooltip>
                          </div>
                          <el-input type="text" v-model="currentForm.policies.titlePrivacyPolicy"></el-input>
                          <span class="error">{{ $errorMessage("titlePrivacyPolicy", validationErrors) }}</span>
                        </div>
                        <div class="registerform-input-container">
                          <div class="custom-label">
                            <label>{{ $t("registrationManagement.registrationForm.registerFormDialog.contracts.privacyPolicyContent") }}</label>
                            <el-tooltip placement="top">
                              <div slot="content" class="custom-tooltip-content">
                                <span>{{ $t("registrationManagement.registrationForm.registerFormDialog.contracts.privacyPolicyContentMsg") }}</span>
                              </div>
                              <i class="el-icon-info"></i>
                            </el-tooltip>
                          </div>
                          <quill-editor ref="myQuillEditor" @ready="onEditorReady($event)" :options="editorOption" style="background-color:white;border-radius:8px;" v-model="currentForm.policies.privacyPolicy" />
                        </div>
                      </div>
                    </transition>
                  </div>
                </div>

                <div class="custom-set-container" :class="currentForm.policies.enableTermsOfUse ? 'sactive' : ''">
                  <div class="custom-set-inner">
                    <i :class="currentForm.policies.enableTermsOfUse ? 'fas fa-check-circle' : 'fas fa-times-circle'"></i>
                    <div class="custom-set-info">
                      <label>
                        {{ $t("registrationManagement.registrationForm.registerFormDialog.contracts.termsOfUse") }}
                      </label>
                      <span>{{ $t("registrationManagement.registrationForm.registerFormDialog.contracts.termsOfUseMsg") }}</span>
                    </div>
                  </div>
                  <div class="custom-set-actions fend">
                    <el-switch v-model="currentForm.policies.enableTermsOfUse"></el-switch>
                  </div>
                  <div class="custom-set-actions fcenter mt-2">
                    <transition name="el-fade-in">
                      <div v-if="currentForm.policies.enableTermsOfUse" style="width: 100%">
                        <div class="registerform-input-container">
                          <div class="custom-label">
                            <label>{{ $t("registrationManagement.registrationForm.registerFormDialog.contracts.termsOfUseTitle") }}</label>
                            <el-tooltip placement="top">
                              <div slot="content" class="custom-tooltip-content">
                                <span>{{ $t("registrationManagement.registrationForm.registerFormDialog.contracts.termsOfUseTitleMsg") }}</span>
                              </div>
                              <i class="el-icon-info"></i>
                            </el-tooltip>
                          </div>
                          <el-input type="text" v-model="currentForm.policies.titleTermsOfUse"></el-input>
                          <span class="error">{{ $errorMessage("titleTermsOfUse", validationErrors) }}</span>
                        </div>
                        <div class="registerform-input-container">
                          <div class="custom-label">
                            <label>{{ $t("registrationManagement.registrationForm.registerFormDialog.contracts.termsOfUseTitleContent") }}</label>
                            <el-tooltip placement="top">
                              <div slot="content" class="custom-tooltip-content">
                                <span>{{ $t("registrationManagement.registrationForm.registerFormDialog.contracts.termsOfUseTitleContentMsg") }}</span>
                              </div>
                              <i class="el-icon-info"></i>
                            </el-tooltip>
                          </div>
                          <quill-editor ref="myQuillEditor" @ready="onEditorReady($event)" :options="editorOption" style="background-color:white;border-radius:8px;" v-model="currentForm.policies.termsOfUse" />
                        </div>
                      </div>
                    </transition>
                  </div>
                </div>
                <div class="custom-set-container" :class="currentForm.policies.enableDistanceSalesPolicy ? 'sactive' : ''">
                  <div class="custom-set-inner">
                    <i :class="currentForm.policies.enableDistanceSalesPolicy ? 'fas fa-check-circle' : 'fas fa-times-circle'"></i>
                    <div class="custom-set-info">
                      <label>
                        {{ $t("registrationManagement.registrationForm.registerFormDialog.contracts.distanceSalesContract") }}
                      </label>
                      <span>{{ $t("registrationManagement.registrationForm.registerFormDialog.contracts.distanceSalesContractMsg") }}</span>
                    </div>
                  </div>
                  <div class="custom-set-actions fend">
                    <el-switch v-model="currentForm.policies.enableDistanceSalesPolicy"></el-switch>
                  </div>
                  <div class="custom-set-actions fcenter mt-2">
                    <transition name="el-fade-in">
                      <div v-if="currentForm.policies.enableDistanceSalesPolicy" style="width: 100%">
                        <div class="registerform-input-container">
                          <div class="custom-label">
                            <label>{{ $t("registrationManagement.registrationForm.registerFormDialog.contracts.distanceSalesContractTitle") }}</label>
                            <el-tooltip placement="top">
                              <div slot="content" class="custom-tooltip-content">
                                <span>{{ $t("registrationManagement.registrationForm.registerFormDialog.contracts.distanceSalesContractTitleMsg") }}</span>
                              </div>
                              <i class="el-icon-info"></i>
                            </el-tooltip>
                          </div>
                          <el-input type="text" v-model="currentForm.policies.titleDistancePolicy"></el-input>
                          <span class="error">{{ $errorMessage("titleDistancePolicy", validationErrors) }}</span>
                        </div>
                        <div class="registerform-input-container">
                          <div class="custom-label">
                            <label>{{ $t("registrationManagement.registrationForm.registerFormDialog.contracts.distanceSalesContractContent") }}</label>
                            <el-tooltip placement="top">
                              <div slot="content" class="custom-tooltip-content">
                                <span>{{ $t("registrationManagement.registrationForm.registerFormDialog.contracts.distanceSalesContractContentMsg") }}</span>
                              </div>
                              <i class="el-icon-info"></i>
                            </el-tooltip>
                          </div>
                          <quill-editor ref="myQuillEditor" @ready="onEditorReady($event)" :options="editorOption" style="background-color:white;border-radius:8px;" v-model="currentForm.policies.distancePolicy" />
                          <div class="registerform-input-container">
                            <div class="custom-label">
                              <label>{{ $t("registrationManagement.registrationForm.registerFormDialog.contracts.distanceSalesContractVariables") }}</label>
                              <el-tooltip placement="top">
                                <div slot="content" class="custom-tooltip-content">
                                  <span>{{ $t("registrationManagement.registrationForm.registerFormDialog.contracts.distanceSalesContractVariablesMsg") }}</span>
                                </div>
                                <i class="el-icon-info"></i>
                              </el-tooltip>
                            </div>
                            <div class="d-flex flex-wrap" style="gap:10px">
                              <el-tag :closable="false" type="primary">%customer.name%</el-tag>
                              <el-tag :closable="false" type="primary">%customer.phoneNumber%</el-tag>
                              <el-tag :closable="false" type="primary">%customer.email%</el-tag>
                              <el-tag :closable="false" type="primary">%payment.total%</el-tag>
                              <el-tag :closable="false" type="primary">%payment.discount%</el-tag>
                              <el-tag :closable="false" type="primary">%payment.paidPrice%</el-tag>
                              <el-tag :closable="false" type="primary">%payment.taxPrice%</el-tag>
                            </div>
                          </div>
                        </div>
                      </div>
                    </transition>
                  </div>
                </div>
              </div>
            </el-card>
          </el-tab-pane>
          <el-tab-pane :label="$t('registrationManagement.registrationForm.registerFormDialog.formSettings.tabName')" name="eight" v-if="currentForm.settings">
            <el-card shadow="never" class="form-base-card">
              <div class="header">
                <div class="title">
                  {{ $t("registrationManagement.registrationForm.registerFormDialog.formSettings.formSettings") }}
                  <span>{{ $t("registrationManagement.registrationForm.registerFormDialog.formSettings.formSettingsMsg") }}</span>
                </div>
              </div>

              <div class="tab-contents">
                <el-row :gutter="20" class="custom-tab-content-row">
                  <el-col class="mt-2" :span="24">
                    <div class="custom-set-container" :class="currentForm.settings.groupRegistrations ? 'sactive' : ''">
                      <div class="custom-set-inner">
                        <i :class="currentForm.settings.groupRegistrations ? 'fas fa-user-friends' : 'fas fa-user'"></i>
                        <div class="custom-set-info">
                          <label>
                            {{ $t("registrationManagement.registrationForm.registerFormDialog.formSettings.groupRegistration") }}
                          </label>
                          <span>{{ $t("registrationManagement.registrationForm.registerFormDialog.formSettings.groupRegistrationMsg") }}</span>
                        </div>
                      </div>
                      <div class="custom-set-actions fend">
                        <el-switch v-model="currentForm.settings.groupRegistrations"></el-switch>
                      </div>
                      <div class="custom-set-actions fcenter mt-2">
                        <transition name="el-fade-in">
                          <div v-if="currentForm.settings.groupRegistrations" style="width: 100%">
                            <el-row :gutter="20">
                              <el-col :span="12" style="display:flex;gap:10px;flex-direction:column;">
                                <label>{{ $t("registrationManagement.registrationForm.registerFormDialog.formSettings.minAttandee") }}</label>
                                <el-input-number v-model="currentForm.settings.groupRegistrationMin" :min="1" :max="100" style="width:100%;"></el-input-number>
                              </el-col>
                              <el-col :span="12" style="display:flex;gap:10px;flex-direction:column;">
                                <label>{{ $t("registrationManagement.registrationForm.registerFormDialog.formSettings.maxAttendee") }}</label>
                                <el-input-number v-model="currentForm.settings.groupRegistrationMax" :min="1" :max="100" style="width:100%;"></el-input-number>
                              </el-col>
                            </el-row>
                          </div>
                        </transition>
                      </div>
                    </div>

                    <div class="custom-set-container" :class="currentForm.settings.enableFormStock ? 'sactive' : ''">
                      <div class="custom-set-inner">
                        <i :class="currentForm.settings.enableFormStock ? 'fas fa-arrows-alt-h' : 'fas fa-arrows-alt-h'"></i>
                        <div class="custom-set-info">
                          <label>
                            {{ $t("registrationManagement.registrationForm.registerFormDialog.formSettings.formStock") }}
                          </label>
                          <span>{{ $t("registrationManagement.registrationForm.registerFormDialog.formSettings.formStockMsg") }}</span>
                        </div>
                      </div>
                      <div class="custom-set-actions fend">
                        <el-switch v-model="currentForm.settings.enableFormStock"></el-switch>
                      </div>
                      <div class="custom-set-actions fcenter mt-2">
                        <transition name="el-fade-in">
                          <div v-if="currentForm.settings.enableFormStock" style="width: 100%">
                            <el-input-number v-model="currentForm.settings.formStock" :min="1" style="width:100%;"></el-input-number>
                          </div>
                        </transition>
                      </div>
                    </div>
                    <div class="custom-set-container" :class="currentForm.settings.invoiceInformation ? 'sactive' : ''">
                      <div class="custom-set-inner">
                        <i :class="currentForm.settings.invoiceInformation ? 'fas fa-file-alt' : 'fas fa-file-alt'"></i>
                        <div class="custom-set-info">
                          <label>
                            {{ $t("registrationManagement.registrationForm.registerFormDialog.formSettings.transaction") }}
                          </label>
                          <span>{{ $t("registrationManagement.registrationForm.registerFormDialog.formSettings.transactionMsg") }}</span>
                        </div>
                      </div>
                      <div class="custom-set-actions fend">
                        <el-switch v-model="currentForm.settings.invoiceInformation"></el-switch>
                      </div>
                    </div>

                    <div class="custom-set-container" :class="currentForm.settings.automaticApprove ? 'sactive' : ''">
                      <div class="custom-set-inner">
                        <i :class="currentForm.settings.automaticApprove ? 'fas fa-check-circle' : 'fas fa-times-circle'"></i>
                        <div class="custom-set-info">
                          <label>
                            {{ $t("registrationManagement.registrationForm.registerFormDialog.formSettings.automaticConfirmation") }}
                          </label>
                          <span>{{ $t("registrationManagement.registrationForm.registerFormDialog.formSettings.automaticConfirmationMsg") }}</span>
                        </div>
                      </div>
                      <div class="custom-set-actions fend">
                        <el-switch v-model="currentForm.settings.automaticApprove" @change="currentForm.settings.automaticApprove ? (currentForm.settings.automaticApproveSettings = []) : '' + currentForm.settings.automaticVoucher ? (currentForm.settings.automaticVoucher = false) + (currentForm.settings.voucherId = null) + (currentForm.settings.automaticVoucherSettings = []) : ''"></el-switch>
                      </div>
                      <div class="custom-set-actions fcenter mt-2">
                        <transition name="el-fade-in">
                          <div v-if="currentForm.settings.automaticApprove" style="width: 100%">
                            <el-select v-if="getEnums" :disabled="!currentForm.settings.automaticApprove" v-model="currentForm.settings.automaticApproveSettings" multiple>
                              <el-option v-for="(item, index) in getEnums.find(x => x.title == 'RegistrationFormAutomaticApproveSettings').enums" :key="index" :label="item.displayName" :value="item.key"></el-option>
                            </el-select>
                          </div>
                        </transition>
                      </div>
                    </div>

                    <div class="custom-set-container" :class="currentForm.settings.automaticVoucher ? 'sactive' : ''">
                      <div class="custom-set-inner">
                        <i :class="currentForm.settings.automaticVoucher ? 'fas fa-paper-plane' : 'fas fa-paper-plane'"></i>
                        <div class="custom-set-info">
                          <label>
                            {{ $t("registrationManagement.registrationForm.registerFormDialog.formSettings.autoVoucher") }}
                          </label>
                          <span>{{ $t("registrationManagement.registrationForm.registerFormDialog.formSettings.autoVoucherMsg") }}</span>
                        </div>
                      </div>
                      <div class="custom-set-actions fend">
                        <el-switch v-model="currentForm.settings.automaticVoucher" :disabled="!currentForm.settings.automaticApprove" @change="currentForm.settings.automaticVoucher ? (currentForm.settings.voucherId = null) + (currentForm.settings.automaticVoucherSettings = []) : ''"></el-switch>
                      </div>
                      <div class="custom-set-actions fcenter mt-2">
                        <transition name="el-fade-in">
                          <div v-if="currentForm.settings.automaticVoucher" style="width: 100%">
                            <el-row :gutter="10">
                              <el-col :span="16">
                                <el-select :disabled="!currentForm.settings.automaticVoucher" v-model="currentForm.settings.voucherId">
                                  <el-option v-for="(item, index) in $store.state.automatedmessages.items.filter(x => x.category == 0)" :key="index" :label="item.title" :value="item.id"></el-option>
                                </el-select>
                              </el-col>
                              <el-col :span="8">
                                <el-select v-if="getEnums" :disabled="!currentForm.settings.automaticVoucher" v-model="currentForm.settings.automaticVoucherSettings" multiple>
                                  <el-option v-for="(item, index) in getEnums.find(x => x.title == 'RegistrationFormAutomaticVoucherSettings').enums" :key="index" :label="item.displayName" :value="item.key"></el-option>
                                </el-select>
                              </el-col>
                            </el-row>
                          </div>
                        </transition>
                      </div>
                    </div>

                    <div class="custom-set-container" :class="currentForm.settings.automaticVoucher ? 'sactive' : ''">
                      <div class="custom-set-inner">
                        <i class="fas fa-cogs"></i>
                        <div class="custom-set-info">
                          <label>
                            Google Tag Manager ID
                          </label>
                          <span></span>
                        </div>
                      </div>
                      
                      <div class="custom-set-actions fcenter mt-2">
                        <transition name="el-fade-in">
                          <div style="width: 100%">
                            <el-row :gutter="10">
                              <el-col :span="24">
                                <el-input type="text" v-model="currentForm.settings.googleAnalysticsId" placeholder="UA-112233"></el-input>
                              </el-col>
                            </el-row>
                          </div>
                        </transition>
                      </div>
                    </div>


                    <div class="custom-set-container" :class="currentForm.settings.enableRegistration ? 'sactive' : 'spassive'">
                      <div class="custom-set-inner">
                        <i :class="currentForm.settings.enableRegistration ? 'fas fa-ticket-alt' : 'fas fa-ticket-alt'"></i>
                        <div class="custom-set-info">
                          <label>
                            {{ $t("registrationManagement.registrationForm.registerFormDialog.formSettings.status") }}
                          </label>
                          <span v-html="$t('registrationManagement.registrationForm.registerFormDialog.formSettings.statusMsg')"></span>
                        </div>
                      </div>
                      <div class="custom-set-actions fend">
                        <el-switch v-model="currentForm.settings.enableRegistration"></el-switch>
                      </div>
                    </div>

                    <div class="custom-set-container" :class="currentForm.settings.isActive ? 'sactive' : 'spassive'">
                      <div class="custom-set-inner">
                        <i class="fa" :class="currentForm.settings.isActive ? 'fa-eye' : 'fa-eye-slash'"></i>
                        <div class="custom-set-info">
                          <label>
                            {{ $t("registrationManagement.registrationForm.registerFormDialog.formSettings.show") }}
                          </label>
                          <span v-html="$t('registrationManagement.registrationForm.registerFormDialog.formSettings.showMsg')"></span>
                        </div>
                      </div>
                      <div class="custom-set-actions fend">
                        <el-switch v-model="currentForm.settings.isActive"></el-switch>
                      </div>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </el-card>
          </el-tab-pane>
        </el-tabs>
      </transition>
    </div>
    <div class="modal-footer" slot="footer" v-if="createLoading != 'created'">
      <div class="left-buttons">
        <el-button @click="$emit('closeDialog')">{{ $t("registrationManagement.registrationForm.registerFormDialog.close") }}</el-button>
        <el-popconfirm @confirm="$emit('deleteMe')" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
          <el-button slot="reference" type="danger" icon="fas fa-trash">{{ $t("registrationManagement.registrationForm.registerFormDialog.delete") }}</el-button>
        </el-popconfirm>
      </div>
      <div class="right-buttons">
        <template v-if="activeKey == 'nine'">
          <el-button type="primary" :loading="loading == 'updatePolicies'" :disabled="loading == 'updatePolicies'" @click="savePolicies">{{ $t("registrationManagement.registrationForm.registerFormDialog.saveContract") }}</el-button>
        </template>
        <template v-if="activeKey == 'one'">
          <el-tooltip class="item" effect="dark" :content="$t('event.buttons.undoChanges')" placement="top-start">
            <el-button type="warning" :loading="loading == 'refresh'" :disabled="loading == 'refresh'" @click="recovery"><i class="fas fa-redo-alt"></i></el-button>
          </el-tooltip>
          <el-button type="primary" :loading="loading == 'formInfo'" :disabled="loading == 'formInfo'" @click="saveFormInfo">{{ $t("registrationManagement.registrationForm.registerFormDialog.saveFormInfo") }}</el-button>
        </template>

        <template v-if="activeKey == 'two'">
          <el-tooltip class="item" effect="dark" :content="$t('event.buttons.undoChanges')" placement="top-start">
            <el-button type="warning" :loading="loading == 'refresh'" :disabled="loading == 'refresh'" @click="recovery"><i class="fas fa-redo-alt"></i></el-button>
          </el-tooltip>
          <el-button type="primary" :loading="loading == 'paymentInfo'" :disabled="loading == 'paymentInfo'" @click="saveFormPaymentInfo">{{ $t("registrationManagement.registrationForm.registerFormDialog.savePaymentInfo") }}</el-button>
        </template>

        <template v-if="activeKey == 'five'">
          <el-tooltip class="item" effect="dark" :content="$t('event.buttons.undoChanges')" placement="top-start">
            <el-button type="warning" :loading="loading == 'refresh'" :disabled="loading == 'refresh'" @click="recovery"><i class="fas fa-redo-alt"></i></el-button>
          </el-tooltip>
          <el-button type="primary" :loading="loading == 'accompayingPerson'" :disabled="loading == 'accompayingPerson'" @click="updateAccompayingPersonSettings()">{{ $t("registrationManagement.registrationForm.registerFormDialog.saveCompanionSettings") }}</el-button>
        </template>

        <template v-if="activeKey == 'eight'">
          <el-tooltip class="item" effect="dark" :content="$t('event.buttons.undoChanges')" placement="top-start">
            <el-button type="warning" :loading="loading == 'refresh'" :disabled="loading == 'refresh'" @click="recovery"><i class="fas fa-redo-alt"></i></el-button>
          </el-tooltip>
          <el-button type="primary" :loading="loading == 'settingsInfo'" :disabled="loading == 'settingsInfo'" @click="saveFormSettingsInfo()">{{ $t("registrationManagement.registrationForm.registerFormDialog.saveFormSettings") }}</el-button>
        </template>

        <template v-if="activeKey == 'seven' && true">
          <el-pagination background layout="total,sizes,prev, pager, next" :current-page.sync="filter.page" @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="filter.take" :total="filter.total" :page-sizes="[10, 20, 30, 40, 50]"></el-pagination>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import MoneyInput from "./Inputs/MoneyInput.vue";
import axios from "axios";
import draggable from "vuedraggable";
import { quillEditor, Quill } from "vue-quill-editor";
import QuillResize from "quill-resize-module";
Quill.register("modules/resize", QuillResize);

import TestPaymentModal from "../../components/register-form/testPaymentModal.vue";
import AddOrUpdatePaymentMethods from "../../components/register-form/addOrUpdatePaymentMehods.vue";
import AddOrUpdateRegistrationPacket from "../../components/register-form/addOrUpdateRegistrationPacket.vue";
import AddOrUpdateRegistrationCategory from "../../components/register-form/addOrUpdateRegistrationCategory.vue";
import AddOrUpdateRegistrationService from "../../components/register-form/addOrUpdateRegistrationService.vue";
import AddOrUpdateRegistrationCoupon from "../../components/register-form/addOrUpdateRegistrationCoupon.vue";
import RegistrationCouponDetails from "./RegistrationCouponDetails.vue";
import QuestionLibrary from "./QuestionLibrary.vue";
export default {
  props: ["id"],
  components: {
    TestPaymentModal,
    draggable,
    quillEditor,
    MoneyInput,
    AddOrUpdateRegistrationPacket,
    AddOrUpdateRegistrationService,
    AddOrUpdateRegistrationCoupon,
    RegistrationCouponDetails,
    AddOrUpdateRegistrationCategory,
    QuestionLibrary,
    AddOrUpdatePaymentMethods
  },
  data() {
    return {
      testPaymentModal: false,
      couponFilterDock: false,
      couponGroups: [],
      filter: {
        page: 1,
        skip: 0,
        take: 20,
        searchTerm: null,
        total: 0
      },
      paymentPosId: null,
      addPaymentMethodDialog: false,
      addServicesQuestionsDock: false,
      accompanyDock: false,
      changes: [],
      currentCouponGroups: [],
      couponDetailDialog: false,
      currentCoupon: false,
      createLoading: false,
      activeKey: "one",
      renderCount: 0,
      couponDialog: false,
      renderCount2: 0,
      couponDetailId: null,
      serviceDialog: false,
      couponId: null,
      packetId: null,
      serviceId: null,
      categoryId: null,
      categoryDialog: false,
      loading: false,
      timeout: null,
      packetChangedTimeout: null,
      packetDragTimeout: null,
      packetDialog: false,
      dragPacket: false,
      validationErrors: [],
      quillUploading: false,

      editorOptionImage: {
        modules: {
          toolbar: {
            container: [["bold", "italic", "underline", "strike"], ["image"]],
            handlers: {
              image: () => {
                this.selectLocalImage();
              }
            }
          },

          syntax: {
            highlight: text => hljs.highlightAuto(text).value
          },

          resize: {
            modules: ["Resize"]
          }
        }
      },
      editorOption: {
        modules: {
          toolbar: [["bold", "italic", "underline", "strike"]],
          syntax: {
            highlight: text => hljs.highlightAuto(text).value
          }
        }
      },
      axios
    };
  },
  async created() {
    await Promise.all([this.recovery(), this.$store.dispatch("getTags")]);
  },
  computed: {
    eventPermissions() {
      return this.$store.getters.getEventPermission;
    },
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    },
    currentOrganization() {
      return this.$store.getters.getCurrentOrganization;
    },
    currentForm() {
      return this.$store.getters.getCurrentRegisterForm;
    },
    getEnums() {
      return this.$store.getters.getEnums;
    },

    getPacketValidation() {
      return this.$store.getters.getPacketValidation;
    },
    getServiceValidation() {
      return this.$store.getters.getServiceValidation;
    },
    getCategoryValidation() {
      return this.$store.getters.getCategoryValidation;
    },
    getAccompayingValidation() {
      return this.$store.getters.getAccompayingValidation;
    }
  },
  methods: {
    formRegistrationTypeRadio(val){
      if(false && val == 1){
        this.currentForm.paymentInfo.formRegistrationType = 0;
        this.openUpgradeDialog();
      }
    },
    selectLocalImage(editor) {
      const input = document.createElement("input");
      input.setAttribute("type", "file");
      input.click();
      input.onchange = () => {
        const file = input.files[0];
        if (/^image\//.test(file.type)) {
          this.saveToServer(file, editor);
          this.quillUploading = "Image upload process started.";
        } else {
          //console.warn("You could only upload images.");
          this.quillUploading = "You could only upload images.";
          setTimeout(() => {
            this.quillUploading = false;
          }, 3000);
        }
      };
    },

    saveToServer(file, editor) {
      const fd = new FormData();

      fd.append("image", file);
      const xhr = new XMLHttpRequest();
      xhr.open("POST", axios.defaults.baseURL + "event/uploadImage?uploadType=html&language=" + this.$i18n.locale, true);
      xhr.setRequestHeader("Authorization", "Bearer " + localStorage.getItem("token"));

      xhr.onload = () => {
        if (xhr.status === 200) {
          const body = JSON.parse(xhr.responseText);
          if (body.alert.hasError == false) {
            const url = body.data.item.url;
            this.insertToEditor(url, editor);
            this.quillUploading = "Image upload process completed successfully.";
            setTimeout(() => {
              this.quillUploading = false;
            }, 3000);
          } else {
            this.$message.error(body.alert.message);
            this.quillUploading = body.alert.message;
            setTimeout(() => {
              this.quillUploading = false;
            }, 3000);
          }
        } else {
          this.quillUploading = xhr.statusText + " (Code: " + xhr.status + ")";
          setTimeout(() => {
            this.quillUploading = false;
          }, 3000);
        }
      };

      xhr.send(fd);
    },

    insertToEditor(url, editor) {
      editor.insertEmbed(editor.getSelection().index, "image", url);
    },
    handleCurrentChange(page) {
      this.filter.page = page;
      var scrollpage = document.querySelector("#scroll-area");
      scrollpage.scrollTo({ top: scrollpage.offsetTop, behavior: "smooth" });
    },
    handleSizeChange(take) {
      this.filter.take = take;
    },
    async filtered() {
      var res = await this.$store.dispatch("registrationCouponGroupList", { registrationFormId: this.currentForm.id, ...this.filter });
      if (!res.data.alert.hasError) {
        this.couponGroups = res.data.data.items;
        this.filter.total = res.data.data.totalCount;
      }
    },
    openDetailCoupon(id) {
      this.currentCoupon = id + "test";
      this.couponDetailId = id;
      this.couponDetailDialog = true;
    },
    handleClick(tab, event) {
      if (tab.name == "four") {
        this.renderCount += 1;
      }
      if (tab.name == "six") {
        this.renderCount2 += 1;
      }
    },
    async updateAccompayingPersonSettings() {
      this.loading = "accompayingPerson";
      var payload = {
        ...this.currentForm.accompayingPerson,
        id: this.id
      };
      await this.$store.dispatch("updateAccompayingPersonSettings", payload);
      this.loading = false;
    },
    async deleteService(id) {
      if (this.timeout != null) clearTimeout(this.timeout);
      this.loading = "delete" + id;
      this.timeout = setTimeout(async () => {
        await this.$store.dispatch("registrationServiceDelete", id);
        this.loading = false;
      }, 500);
    },
    async deleteCategory(id) {
      if (this.timeout != null) clearTimeout(this.timeout);
      this.loading = "delete" + id;
      this.timeout = setTimeout(async () => {
        await this.$store.dispatch("registrationCategoryDelete", id);
        this.loading = false;
      }, 500);
    },
    openExcellDialog() {
      this.exportXlsx(12, this.currentForm.id, null);
    },
    async deletePacket(id) {
      if (this.timeout != null) clearTimeout(this.timeout);
      this.loading = "delete" + id;
      this.timeout = setTimeout(async () => {
        await this.$store.dispatch("registrationPacketDelete", id);
        this.loading = false;
      }, 500);
    },
    async deleteCoupon(id) {
      if (this.timeout != null) clearTimeout(this.timeout);
      this.loading = "delete" + id;
      this.timeout = setTimeout(async () => {
        await this.$store.dispatch("registrationCouponDelete", id);
        this.filtered();
        this.loading = false;
      }, 500);
    },
    packetTitle(packetId) {
      return this.currentForm.packets.find(x => x.id == packetId).title;
    },
    async deleteProviders(id) {
      this.loading = "delete" + id;
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch("deletePaymentProviders", id);
        if (!res.data.alert.hasError) {
          await this.$store.dispatch("getOrganization");
        }
        this.loading = false;
      }, 500);
    },
    async changePacketSort() {
      if (this.packetDragTimeout != null) clearTimeout(this.packetDragTimeout);
      this.packetDragTimeout = setTimeout(async () => {
        var payload = [];
        this.currentForm.packets.map(x => {
          payload.push(x.id);
        });
        await this.$store.dispatch("savePacketOrders", payload);
      }, 500);
    },
    async changeServiceSort() {
      if (this.packetDragTimeout != null) clearTimeout(this.packetDragTimeout);
      this.packetDragTimeout = setTimeout(async () => {
        var payload = [];
        this.currentForm.additionalServices.map(x => {
          payload.push(x.id);
        });
        await this.$store.dispatch("saveServiceOrders", payload);
      }, 500);
    },
    async changeCategoryShort() {
      if (this.packetDragTimeout != null) clearTimeout(this.packetDragTimeout);
      this.packetDragTimeout = setTimeout(async () => {
        var payload = [];
        this.currentForm.additionalServiceCategories.map(x => {
          payload.push(x.id);
        });
        await this.$store.dispatch("saveCategoryOrders", payload);
      }, 500);
    },
    async refreshForm() {
      this.loading = "refreshList";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        await this.$store.dispatch("getRegisterFormOne", this.id);
        await this.$store.dispatch("getOrganization");
        this.loading = false;
      }, 500);
    },
    async recovery() {
      this.activeKey = "one";
      this.loading = "refresh";
      this.createLoading = "created";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        await this.$store.dispatch("getRegisterFormOne", this.id);
        await this.$store.dispatch("getOrganization");
        await this.filtered();
        this.createLoading = false;
        var dummyLimit = [];
        this.currentForm.accompayingPerson.packetLimitations.forEach(x => {
          if (this.currentForm.packets.some(y => y.id == x.packetId)) {
            dummyLimit.push(x);
          }
        });
        this.currentForm.accompayingPerson.packetLimitations = dummyLimit;
        // if (this.currentForm.accompayingPerson.isActivePacketLimitations) {
        //   window.jQuery('.custom-radio-containerr').show();
        // } else {
        //   window.jQuery('.custom-radio-containerr').hide();
        // }
        // if (this.currentForm.accompayingPerson.isActiveStockControl) {
        //   window.jQuery('.custom-radio-stock-controller').show();
        // } else {
        //   window.jQuery('.custom-radio-stock-controller').hide();
        // }
      }, 500);

      this.loading = false;
    },
    async changedPacket(item) {
      if (this.packetChangedTimeout != null) clearTimeout(this.packetChangedTimeout);
      this.packetChangedTimeout = setTimeout(async () => {
        this.currentCoupon = item.id;
        this.loading = "packetChanged-" + item.id;
        var res = await this.$store.dispatch("savePacketMini", item);
        if (!res.data.alert.hasError) {
          await this.$store.dispatch("getRegisterFormOne", this.id);
        }
        this.currentCoupon = false;
        this.loading = false;
      }, 500);
    },
    async changedCoupon(item) {
      if (this.packetChangedTimeout != null) clearTimeout(this.packetChangedTimeout);
      this.packetChangedTimeout = setTimeout(async () => {
        this.currentCoupon = item.id;
        this.loading = "couponChanged-" + item.id;
        await this.$store.dispatch("saveCouponMini", item.id);

        await this.recovery();
        this.loading = false;
        this.currentCoupon = false;
      }, 500);
    },
    async changedService(item) {
      if (this.packetChangedTimeout != null) clearTimeout(this.packetChangedTimeout);
      this.packetChangedTimeout = setTimeout(async () => {
        this.currentCoupon = item.id;
        this.loading = "serviceChanged-" + item.id;
        var payload = {
          id: item.id,
          title: item.title,
          stock: item.stock,
          isActive: item.isActive,
          price: item.price
        };
        var res = await this.$store.dispatch("saveServiceMini", payload);
        if (!res.data.alert.hasError) {
          await this.$store.dispatch("getRegisterFormOne", this.id);
        }
        this.currentCoupon = false;

        this.loading = false;
      }, 500);
    },
    async changedCategory(item) {
      if (this.packetChangedTimeout != null) clearTimeout(this.packetChangedTimeout);
      this.packetChangedTimeout = setTimeout(async () => {
        this.currentCoupon = item.id;
        this.loading = "categoryChanged-" + item.id;
        var payload = {
          id: item.id,
          title: item.title,
          isActive: item.isActive
        };
        var res = await this.$store.dispatch("saveCategoryMini", payload);
        if (!res.data.alert.hasError) {
          await this.$store.dispatch("getRegisterFormOne", this.id);
        }
        this.currentCoupon = false;
        this.loading = false;
      }, 500);
    },
    addUpdateCoupon(id) {
      this.currentCoupon = id + "test";
      this.couponId = id;
      this.couponDialog = true;
    },
    async reminderCouponGroup(id) {
      this.loading = "reminderCoupon-" + id;
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        await this.$store.dispatch("reminderCouponGroup", id);
        this.loading = false;
      }, 500);
    },
    addUpdatePacket(id) {
      this.currentCoupon = id + "test";
      this.packetId = id;
      this.packetDialog = true;
    },
    addUpdateCategory(id) {
      this.categoryId = id;
      this.categoryDialog = true;
    },
    addUpdateService(id) {
      this.currentCoupon = id + "test";
      this.serviceId = id;
      this.serviceDialog = true;
    },
    async saveFormSettingsInfo() {
      this.loading = "settingsInfo";
      var payload = {
        id: this.id,
        ...this.currentForm.settings
      };
      await this.$store.dispatch("saveRegisterFormSettingsInfo", payload);
      this.loading = false;
    },
    async savePolicies() {
      this.loading = "updatePolicies";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        await this.$store.dispatch("savePoliciesForm", { id: this.id, ...this.currentForm.policies });
        this.loading = false;
      }, 500);
    },
    async saveFormInfo() {
      this.loading = "formInfo";
      var payload = {
        id: this.id,
        ...this.currentForm.formInfo
      };
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch("saveRegisterFormInfo", payload);
        this.validationErrors = res.data.validationErrors;
        this.loading = false;
      }, 500);
    },
    async saveFormPaymentInfo() {
      this.loading = "paymentInfo";
      var payload = {
        id: this.id,
        ...this.currentForm.paymentInfo
      };
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch("saveRegisterFormPaymentInfo", payload);
        this.validationErrors = res.data.validationErrors;
        this.loading = false;
      }, 500);
    },
    topBannerSuccess(response) {
      console.log(response, "el-upload");
      if (response.alert.hasError) {
        this.$message.error(response.alert.message);
      } else {
        this.$message.success(response.alert.message);
        this.currentForm.formInfo.topBanner = response.data.item.url;
      }
    },
    changeCurrency() {
      this.currentForm.paymentInfo.posId = null;
    },
    bottomBannerProgress() {
      this.loading = "bottomBanner";
    },
    bottomBannerSuccess(response) {
      if (response.alert.hasError) {
        this.$message.error(response.alert.message);
      } else {
        this.$message.success(response.alert.message);
        this.currentForm.formInfo.bottomBanner = response.data.item.url;
      }
      this.loading = false;
    },
    closeMe() {
      this.$emit("closeMe");
    },
    async closeCouponDialog() {
      this.couponDialog = false;
      await this.filtered();
    },
    closePacketDialog() {
      this.packetDialog = false;
    },
    closeServiceDialog() {
      this.serviceDialog = false;
    },
    closeCategoryDialog() {
      this.categoryDialog = false;
    },
    onEditorReady(editor) {
      editor.root.setAttribute("data-placeholder", this.$t("enterText"));
      editor.getModule("toolbar").addHandler("image", () => {
        this.selectLocalImage(editor);
      });
    }
  },
  watch: {

    activeKey: function() {
      this.validationErrors = [];
    },
    async id() {
      await this.recovery();
    },
    filter: {
      deep: true,
      async handler() {
        if (this.timeout != null) clearTimeout(this.timeout);
        this.timeout = setTimeout(async () => {
          if (this.currentForm != null) {
            await this.filtered();
          }
        }, 500);
      }
    }
    // currentForm: async function() {
    //   await this.filtered();
    // },
    // 'currentForm.accompayingPerson.isActivePacketLimitations': function(newVal) {
    //   console.log('cc', newVal);
    //   if (newVal) {
    //     window.jQuery('.custom-radio-containerr').slideToggle();
    //   } else {
    //     window.jQuery('.custom-radio-containerr').slideToggle();
    //   }
    // },
    // 'currentForm.accompayingPerson.isActiveStockControl': function(newVal) {
    //   console.log('cc', newVal);
    //   if (newVal) {
    //     window.jQuery('.custom-radio-stock-controller').slideToggle();
    //   } else {
    //     window.jQuery('.custom-radio-stock-controller').slideToggle();
    //   }
    // },
  }
};
</script>

<style lang="less">
#register-form-add-or-update-dialog {
  .modal-body {
    min-height: calc(~"100vh - 239px");
  }

  .el-upload-dragger {
    height: auto;
    width: 100%;
    aspect-ratio: 11.2/1;

    .el-icon-upload {
      margin: 10px !important;
      font-size: 30px !important;
      line-height: 20px !important;
    }
  }
}

.banner-img {
  height: auto;
  width: 100%;
  aspect-ratio: 11.2/1;
}

.tab-contents {
  .registerform-input-container {
    margin-top: 16px;
    .online-payments-container {
      display: flex;
      flex-direction: column;
      gap: 10px;
      .payment-add-buttons {
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }

      .online-payment-list-header {
        grid-template-columns: 1fr 1fr 150px;
      }
      .online-payment-list-items {
        display: flex;
        flex-direction: column;
        gap: 10px;
        .item {
          margin-bottom: 8px;
          i.burger {
            box-sizing: border-box;
            font-size: 20px;
            color: #505763;
            cursor: grab;
            &.me {
              color: #ccc;
            }
          }
          .btn-list {
            display: flex;
            flex-direction: row;
            width: 100%;
            justify-content: flex-end;
            gap: 0.2rem;
            .el-button {
              margin: 0;
            }
          }
          padding: 10px;
          gap: 0.5rem;
          align-items: center;
          display: grid;
          border-radius: 8px;
          grid-template-columns: 1fr 1fr 150px;
          background-color: #f1f1f1;

          &:last-child {
            margin-bottom: unset;
          }
          &.passive {
            background-color: #fff2f2 !important;
          }
          .stand-grid-item-img-title {
            display: flex;
            gap: 1rem;
            font-weight: 500;
            align-items: center;
            .stand-grid-item-title {
              font-weight: bold;
              display: flex;
              flex-direction: column;
              gap: 0.25rem;
            }

            & > .img {
              border-radius: 8px;
              width: 112px;
              height: 50px;
              background-size: cover;
              background-position: center center;
              background-repeat: no-repeat;
              overflow: hidden;
              border: 3px solid white;
            }
          }
        }
      }
    }
  }
}

.form-base-card {
  &.el-card {
    border: none;
  }

  .el-card__body {
    padding: 0px 0px 0px 20px !important;

    .header {
      margin-bottom: 20px;
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      gap: 1rem;

      .title {
        display: flex;
        flex-direction: column;
        font-weight: bold;
        color: #292f3b;
        font-size: 18px;

        span {
          color: #505763;
          font-weight: 400;
          line-height: 1.3;
          font-size: 14px;
        }
      }

      .actions {
        display: block;

        .el-button-group {
          width: max-content;
        }
      }

      .packet-title {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        font-weight: bold;

        .packet-title-base {
          display: flex;
          align-items: center;
          gap: 1rem;
        }
      }

      span {
        font-weight: 400;
      }
    }
  }
}

.custom-radio-group {
  margin-top: 1rem;
}

.coupon-head {
  display: grid;
  grid-template-columns: 4fr 3fr 3fr 3fr 2fr 5fr;
  padding: 10px;
  margin-top: 1rem;
  background-color: #f1f1f1;
  border-radius: 8px;
  margin-bottom: 0.5rem;
  gap: 0.5rem;
  font-weight: bold;
}

.category-head {
  display: grid;
  grid-template-columns: 1.5fr 90px 90px;
  padding: 10px;
  margin-top: 1rem;
  background-color: #f1f1f1;
  border-radius: 8px;
  margin-bottom: 0.5rem;
  gap: 0.5rem;
  font-weight: bold;
}
.packet-head {
  display: grid;
  grid-template-columns: 1.5fr 1fr 90px 90px;
  padding: 10px;
  margin-top: 1rem;
  background-color: #f1f1f1;
  border-radius: 8px;
  margin-bottom: 0.5rem;
  gap: 0.5rem;
  font-weight: bold;
}

#coupon-container {
  .packagelimits {
    span {
      padding: 5px 10px;
      width: max-content;
      border-radius: 8px;
      background-color: rgba(255, 255, 255, 0.8);
      font-weight: 600;
      color: #505763;
      font-size: 13px;
    }
  }

  .item {
    display: grid;
    grid-template-columns: 4fr 3fr 3fr 3fr 2fr 5fr;
    padding: 10px;
    margin-bottom: 0.5rem;
    align-items: center;
    border-radius: 8px;
    background-color: #f1f1f1;
    transition: all 0.5s;

    &.passive {
      background-color: #fff2f2 !important;
    }

    gap: 0.5rem;

    & > .price-title {
      font-weight: bold;
      flex-direction: row;
      gap: 0.5rem;

      .el-input {
        width: 100%;
      }
    }

    .el-input-number {
      width: 100%;
    }

    .el-date-editor {
      width: 100%;
    }

    & > .title {
      flex-shrink: 0;
      display: flex;
      flex-direction: column;
      align-items: center;

      i.burger {
        &.me {
          color: #505763;
        }

        font-size: 20px;
      }

      & > i.el-icon-loading {
        font-size: 20px;
      }
    }

    & > div:last-child {
      justify-self: flex-end;
    }
  }
}
#category-container {
  .item {
    display: grid;
    grid-template-columns: 1.5fr 90px 90px;
    padding: 10px;
    margin-bottom: 0.5rem;
    align-items: center;
    border-radius: 8px;
    background-color: #f1f1f1;
    transition: all 0.5s;

    &.passive {
      background-color: #fff2f2 !important;
    }

    gap: 0.5rem;

    & > .price-title {
      font-weight: bold;
      flex-direction: row;
      gap: 0.5rem;

      .el-input {
        width: 100%;
      }
    }

    .el-input-number {
      width: 100%;
    }

    .el-date-editor {
      width: 100%;
    }

    & > div {
      flex-shrink: 0;
      display: flex;
      flex-direction: column;
      align-items: center;

      i.burger {
        box-sizing: border-box;
        font-size: 20px;
        color: #505763;
        cursor: grab;
      }

      & > i.el-icon-loading {
        font-size: 20px;
      }
    }

    & > div:last-child {
      justify-self: flex-end;
    }
  }
}
#packet-container {
  .item {
    display: grid;
    grid-template-columns: 1.5fr 1fr 90px 90px;
    padding: 10px;
    margin-bottom: 0.5rem;
    align-items: center;
    border-radius: 8px;
    background-color: #f1f1f1;
    transition: all 0.5s;

    &.passive {
      background-color: #fff2f2 !important;
    }

    gap: 0.5rem;

    & > .price-title {
      font-weight: bold;
      flex-direction: row;
      gap: 0.5rem;

      .el-input {
        width: 100%;
      }
    }

    .el-input-number {
      width: 100%;
    }

    .el-date-editor {
      width: 100%;
    }

    & > div {
      flex-shrink: 0;
      display: flex;
      flex-direction: column;
      align-items: center;

      i.burger {
        box-sizing: border-box;
        font-size: 20px;
        color: #505763;
        cursor: grab;
      }

      & > i.el-icon-loading {
        font-size: 20px;
      }
    }

    & > div:last-child {
      justify-self: flex-end;
    }
  }
}

.custom-radio-table-title {
  &.stock-row {
    grid-template-columns: 4fr 1fr;
  }

  &.stock {
    grid-template-columns: 4fr 1fr;
  }

  padding: 10px;
  margin-bottom: 0.5rem;
  background-color: #f1f1f1;
  border-radius: 8px;
  margin-bottom: 0.5rem;
  gap: 0.5rem;
  font-weight: bold;

  display: grid;
  color: #292f3b;
  cursor: pointer;
  font-size: 14px;
  align-items: center;
  grid-template-columns: 8fr 1fr 1fr 1fr;

  &:last-child {
    margin-bottom: unset;
  }
}

.collapse-title-editing {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  .el-switch {
    margin-right: 1rem;
  }
}

.custom-radio-table-title.base {
  .el-radio__label {
    display: none;
  }
}
</style>
<style>
.add-update-packet-dialog {
  min-width: 1000px !important;
  max-width: 1000px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/register-form/registerFormDialog.vue